<template>
    <div class="muven-container">
        <div class="muven-router-name-container">
            <p class="muven-router-name">Auditoria</p>
        </div>    

        <AuditInstanceListCmp v-if="showInstanceList">
            <template v-slot:auditToggle>
                <div class="text-right pull-right" v-show="showToggleButtons">
                    <div class="btn-group">
                        <button class="btn btn-outline-secondary active"
                            @click="showInstanceListHandler()">
                                Geral
                        </button>

                        <button class="btn btn-outline-secondary"
                            @click="showMuvenApiListHandler()">
                                Muven Api
                        </button>
                    </div>
                </div>
            </template>
        </AuditInstanceListCmp>

        <AuditMuvenApiListCmp v-if="showMuvenApiList">
            <template v-slot:auditToggle>
                <div class="text-right pull-right" v-show="showToggleButtons">
                    <div class="btn-group">
                        <button class="btn btn-outline-secondary"
                            @click="showInstanceListHandler()">
                                Geral
                        </button>

                        <button class="btn btn-outline-secondary active"
                            @click="showMuvenApiListHandler()">
                                Muven Api
                        </button>
                    </div>
                </div>
            </template>
        </AuditMuvenApiListCmp>
    </div>
</template>

<script>
import AuditInstanceListCmp from '@/audit/components/AuditInstanceListCmp'
import AuditMuvenApiListCmp from '@/audit/components/AuditMuvenApiListCmp'

export default {
    name: 'AuditListWrapperView',
    components: {
        AuditInstanceListCmp,
        AuditMuvenApiListCmp,
    },
    data() {
        return {
            showToggleButtons: true,
            showInstanceList: true,
            showMuvenApiList: false,
        }
    },
    methods: {
        showMuvenApiListHandler() {
            this.showInstanceList = false;
            this.showMuvenApiList = true;
        },
        showInstanceListHandler() {
            this.showMuvenApiList = false;
            this.showInstanceList = true;
        },
    },
    mounted() {
        if (!!this.$route.query.custom) {
            this.showToggleButtons = false
        }
    },
}
</script>

